<script setup>
import { onMounted} from "vue"
// import { computed } from "vue"
// import { useUserSettingsStore } from "@/store/userSettings";
import TZHeader from "@/components/TZHeader.vue";
import { auth } from '@/Services/ApiServices'
  /* global __APP_VERSION__ */
  const appVersion = __APP_VERSION__

  onMounted(async () => {
    try {
      const result = await auth.login('N663', 'Cmni8hn3e')
      console.log('✅ Login success:', result)
    } catch (e) {
      console.error('❌ Login failed:', e.response?.data || e)
    }
  })
</script>

<template>
  <v-main class="tz-home">
    <!-- Optional overlay content on top of the background -->
    <div class="tz-home-overlay">
      <TZHeader class="tz-home-header" />
      <!-- if you want some text or buttons here later, drop them in -->
    </div>
  </v-main>

  <v-footer app class="d-flex flex-column nvav-orange">
    <div class="py-3 nvav-blue w-100 text-center">
      <i>Dream it - Build it - Fly it!</i>
    </div>

    <div class="home-footer bg-black px-4 py-3 text-center w-100">
      &copy;&nbsp;{{ new Date().getFullYear() }} — <strong>J. Sint Jago - v{{ appVersion }}</strong>
    </div>
  </v-footer>

</template>

<style scoped>
.nvav-orange {
  //background-color: #f57c00;
  color:whitesmoke;
}
.nvav-blue {
  background-color: #4682b4;
}
footer {
  padding: 2px 0 0 0;
}

/* v-main with background image */
.tz-home {
  position: relative;
  min-height: 100vh;
  display: flex;
  background-color: gray; /* base color */
  //overflow: hidden;
  //flex-direction: column;
}

/* background image layer */
.tz-home::before {
  content: "";
  position: absolute;
  inset: 0; /* top:0; right:0; bottom:0; left:0; */
  background-image: url("https://nvav.nl/sites/default/files/TzHomeImage.png");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: contain;
  opacity: 0.3;          /* 👈 pure transparency control */
  pointer-events: none;  /* clicks go through */
  z-index: 0;
}

/* make sure your content is above the background */
.tz-home-overlay {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 1rem 2rem;
}
/* Optional: tweak header width / max width */


</style>
